<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn class="mfe-2" v-if="$policy('promotion').create" :to="{name: 'promotions.create', params: {type: PromotionType.LINK}}" />
            <FilterIt class="mfe-2" :type="PromotionType.LINK"/>
            <SortIt class="mr-auto" :type="PromotionType.LINK"/>
        </CCol>
    </CRow>

    <Table class="mt-2" v-if="$policy('promotion').create" :type="PromotionType.LINK" />
    <Grid v-else class="mt-2" :type="PromotionType.LINK"/>
</CContainer>
</template>

<script>
import { mapActions } from 'vuex'
import { PromotionType } from '@/constants'
import { Table, Grid, FilterIt, SortIt } from './partials'

export default {
    name: 'Links',

    components: {
        SortIt,
        Table,
        Grid,
        FilterIt
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetch({
                page: 1,
                type: PromotionType.LINK
            })
        })
    },

    data() {
        return {
            PromotionType
        }
    },

    computed: {

    },

    methods: {
        ...mapActions('promotion', [
            'fetch'
        ]),
    }
}
</script>